module.exports = __webpack_public_path__ + "media/images/plus-89f7c16e85d8ff2418951b8939c5b4cf.png";